export default {"src":"/_next/static/media/calendar.94dc0f96.svg","height":22,"width":20,"blurWidth":0,"blurHeight":0};